import { IUser } from '@interfaces/IUser';

export interface IAuthStateErrors {
  password?: string[];
  email?: string[];
  detail?: string;
  code?: string[];
  old_password?: string[];
  confirm_password?: string[];
}

export interface ITokens {
  refresh?: string;
  access: string;
}

export interface IAuthState {
  errors: IAuthStateErrors;
  tokens: ITokens;
  user: IUser;
  isAuth: boolean;
  message: string;
  isValidToken: boolean;
  loading?: {
    verifyEmail?: boolean;
    login?: boolean;
    resetPassword?: boolean;
    tokenValidity?: boolean;
    verifyPhone?: boolean;
    editProfile?: boolean;
    changePassword?: boolean;
  };
}

export const initialAuthState: IAuthState = {
  errors: {},
  tokens: {
    access: '',
  },
  isAuth: false,
  user: {},
  message: '',
  isValidToken: false,
};
